import * as React from 'react';
import { Placement } from '../placement';
import { useAdSenseSearchResult } from '../../hooks/adSense';
import { AdSenseForShopping } from '../ad-sense-for-shopping';
import { useDeviceType } from '../../hooks/deviceType';

import {
    SearchResultBannersSpacing,
    Props,
} from './search-result-banners-server';
import { getConfig } from '../../config';
import { useCallback } from 'react';
import { DeviceType, Subvertical, Vertical } from '../../../shared/types/ast';
import { SearchSummary } from '../../../shared/types/adsense';

export function getType(index: number, showAdSenseBoards: boolean) {
    const config = getConfig();
    const hasContentMarketing = config?.contentMarketing?.length > 0;
    if (hasContentMarketing && index === 2) {
        return 'content-marketing';
    }
    if (index !== 1 && showAdSenseBoards) {
        return 'shopping';
    }
    return 'ast';
}

const SearchResultBannersClient: React.FC<Props> = (props) => {
    const {
        cols = 1,
        vertical,
        subvertical,
        deviceType: deviceTypeFromServer,
        searchSummary,
    } = props;

    const deviceType = useDeviceType(deviceTypeFromServer);
    const children = React.Children.toArray(props.children);

    const { showAdSense, showAdSenseBoards } = useAdSenseSearchResult(
        children,
        deviceType,
        vertical,
        searchSummary,
        cols !== 1,
        children.length === 0,
    );

    const spacer = useCallback(
        (id, index) => (
            <Placement
                id={id}
                grid={cols !== 1}
                vertical={vertical}
                subvertical={subvertical}
                key={id}
                deviceType={deviceType}
                showBanners={true}
                type={getType(index, showAdSenseBoards)}
            />
        ),
        [cols, deviceType, vertical, subvertical, showAdSenseBoards],
    );

    return (
        <>
            <SearchResultBannersSpacing
                deviceType={deviceType}
                cols={cols}
                vertical={vertical}
                subvertical={subvertical}
                spacer={spacer}
            >
                {children}
            </SearchResultBannersSpacing>
            {showAdSense && (
                <AdSenseForShopping
                    id="afshcontainer"
                    deviceType={deviceType}
                />
            )}
        </>
    );
};

export type TSearchResultBannersWCReact = {
    id: string;
    index: number;
    cols?: 1 | 2 | 3;
    vertical?: Vertical;
    subvertical?: Subvertical;
    deviceType?: DeviceType;
    searchSummary?: SearchSummary;
};

export const SearchResultBannersWCReact = (
    props: TSearchResultBannersWCReact,
) => {
    const {
        id,
        index,
        cols = 1,
        vertical,
        subvertical,
        deviceType: deviceTypeFromServer,
        searchSummary,
    } = props;
    const deviceType = useDeviceType(deviceTypeFromServer);

    function getType(index: number, showAdSenseBoards: boolean) {
        const config = getConfig();
        const hasContentMarketing = config?.contentMarketing?.length > 0;
        if (hasContentMarketing && index === 2) {
            return 'content-marketing';
        }
        if (index !== 1 && showAdSenseBoards) {
            return 'shopping';
        }
        return 'ast';
    }

    const { showAdSense, showAdSenseBoards } = useAdSenseSearchResult(
        [],
        deviceType,
        vertical,
        searchSummary,
        cols !== 1,
        true,
    );

    if (showAdSense) {
        return (
            <AdSenseForShopping id="afshcontainer" deviceType={deviceType} />
        );
    } else {
        return (
            <Placement
                id={id}
                grid={cols !== 1}
                vertical={vertical}
                subvertical={subvertical}
                key={id}
                deviceType={deviceType}
                slotAd={true}
                showBanners={true}
                type={getType(index, showAdSenseBoards)}
            />
        );
    }
};

export default SearchResultBannersClient;
